const CATALOG_INPUT_FIELDS = [
  'itemId',
  'name',
  'invoiceDescription',
  'quantityType',
  'quantity',
  'amount',
  'blockItemUsedIn',
  'addBlockItemAdjustedItems',
  'deleteBlockItemAdjustedItems',
  'unitPrice',
  'costPrice',
  'businessHoursUnitPrice',
  'afterHoursUnitPrice',
  'category',
  'roundUpValue',
  'useAsWorklogItem',
  'adjustBlockItemAgainstAllItems',
  'salesTax',
  'salesTaxEnabled'
];

export { CATALOG_INPUT_FIELDS };
